
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false); // Luk mobil menu efter klik
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Gofragt.dk
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('fordele')}
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
            >
              Fordele
            </button>
            <button 
              onClick={() => scrollToSection('kontakt')}
              className="text-gray-700 hover:text-teal-600 font-medium transition-colors cursor-pointer"
            >
              Kontakt
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button 
              onClick={() => scrollToSection('kontakt')}
              className="bg-teal-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Få Tilbud
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-teal-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t">
              <button 
                onClick={() => scrollToSection('services')}
                className="block w-full text-left px-3 py-2 text-gray-700 hover:text-teal-600 font-medium cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('fordele')}
                className="block w-full text-left px-3 py-2 text-gray-700 hover:text-teal-600 font-medium cursor-pointer"
              >
                Fordele
              </button>
              <button 
                onClick={() => scrollToSection('kontakt')}
                className="block w-full text-left px-3 py-2 text-gray-700 hover:text-teal-600 font-medium cursor-pointer"
              >
                Kontakt
              </button>
              <button 
                onClick={() => scrollToSection('kontakt')}
                className="block w-full text-left px-3 py-2 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-colors cursor-pointer"
              >
                Få Tilbud
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
